import defineComponent from 'flight';
import WithAjax from 'static/script/app/data/with-ajax';
import WhenLoggedIn from 'static/script/utils/when-logged-in';

function FavouriteSellersService() {
    this._addFavouriteSeller = function (evt, payload) {
        this._whenLoggedIn(function () {
            let successCallback = function (response) {
                if (response && response.message === 'OK') {
                    this.trigger(document, 'data:favourite-sellers:after-added', payload);
                }
            }.bind(this);

            this._post({
                url: '/my/favourite-sellers/add',
                data: payload,
                success: successCallback
            });
        }.bind(this));
    };

    this._removeFavouriteSeller = function (evt, payload) {
        this._whenLoggedIn(function () {
            let successCallback = function (response) {
                if (response && response.message === 'OK') {
                    this.trigger(document, 'data:favourite-sellers:after-removed', payload);
                }
            }.bind(this);

            this._post({
                url: '/my/favourite-sellers/remove',
                data: payload,
                success: successCallback
            });

        }.bind(this));
    };

    this.after('initialize', function () {
        this.on(document, 'ui:favourite-sellers:on-adding', this._addFavouriteSeller);
        this.on(document, 'ui:favourite-sellers:on-removing', this._removeFavouriteSeller);
    });
}

module.exports = defineComponent.component(FavouriteSellersService, WithAjax, WhenLoggedIn);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/data/favourite-sellers-service.js